

























































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import Referensi from "@/services/Referensi";
import LaporanRl1Ranap, {
  Rp1BorBaris,
  Rp1DataBor,
  Rp1DataPenderita,
  Rp1PenderitaRinci,
  Rp1Report
} from "@/services/LaporanRl1Ranap";
import RekapHarianTable from "@/components/laporan/RekapHarianTable.vue";
import { RekapWard } from "@/services/RekapHarianPasienRanap";
import { userModule } from "@/store/modules/user";

interface UnitOption {
  id: string;
  nama: string;
}

@Component({ components: { RekapHarianTable } })
export default class LaporanRl1RanapPage extends Vue {
  month = moment().subtract(1, "month").format("YYYY-MM");
  maxMonth = moment().format("YYYY-MM");
  showMonth = false;

  selectedUnits: string[] = [];
  unitOptions: UnitOption[] = [];
  loadingUnits = false;

  activeReport: Rp1Report = "rekap-harian";
  canEdit = false;
  loadedReport: Rp1Report | null = null;
  loading = false;
  printing = false;
  exporting = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any = null;

  reports = [
    { report: "rekap-harian" as Rp1Report, title: "Rekap Harian", desc: "Sensus harian per bangsal: pasien awal/masuk/keluar/mati + sisa per kelas." },
    { report: "jumlah-pasien" as Rp1Report, title: "Jumlah Pasien", desc: "Masuk / keluar / meninggal harian dipisah jenis kelamin (L/P)." },
    { report: "data-kematian" as Rp1Report, title: "Data Kematian", desc: "Daftar pasien meninggal: identitas, <48j/≥48j, diagnosa, jenis bayar." },
    { report: "jenis-bayar" as Rp1Report, title: "Jenis Bayar", desc: "Matriks harian jenis bayar (awal/masuk/keluar) + gender + kelas." },
    { report: "data-penderita" as Rp1Report, title: "Data Penderita", desc: "Pasien dirawat (awal + masuk) per bangsal L/P dan per cara bayar, rinci per bangsal × cara bayar dan × kelas (awal/masuk/dirawat), hari rawat dan BOR Bayi vs Anak & Dewasa." },
    { report: "data-penderita-meninggal" as Rp1Report, title: "Dirawat & Meninggal", desc: "Pasien dirawat per bangsal L/P beserta penderita meninggal <48 jam dan ≥48 jam, dengan rekap menurut jenis kelamin dan lama dirawat." },
    { report: "data-bor" as Rp1Report, title: "Data BOR", desc: "Jumlah pasien L/P, TT, lama dirawat, dan hari perawatan per bangsal beserta BOR, LOS, TOI, BTO, dikelompokkan Bayi dan Anak & Dewasa." }
  ];

  readonly excelReports: Rp1Report[] = ["data-penderita", "data-penderita-meninggal", "data-bor"];

  readonly kolomMeninggal = ["dirawat", "lt48", "ge48"];

  readonly kelasBagian: ("awal" | "masuk")[] = ["awal", "masuk"];

  rekapCols = [
    { key: "awal", label: "Awal" },
    { key: "masuk", label: "Masuk" },
    { key: "pindahan", label: "Pindahan" },
    { key: "jumlah", label: "Jumlah" },
    { key: "dipindah", label: "Dipindah" },
    { key: "keluar_hidup", label: "Kel. Hidup" },
    { key: "mati_total", label: "Mati" },
    { key: "mati_ge48", label: "≥48j" },
    { key: "mati_lt48", label: "<48j" },
    { key: "jumlah_out", label: "Jml Kel." },
    { key: "lama_dirawat", label: "Lama Dirawat" },
    { key: "sama_hari", label: "Klr/Msk Sama" },
    { key: "sisa", label: "Sisa" }
  ];

  kelasCols = [
    { key: "vip_non", label: "VIP/Non" },
    { key: "k1", label: "I" },
    { key: "k2", label: "II" },
    { key: "k3", label: "III" },
    { key: "iso", label: "Isolasi" }
  ];

  genderEvents = [
    { key: "masuk", label: "Masuk" },
    { key: "pindahan", label: "Pindahan" },
    { key: "keluar", label: "Keluar" },
    { key: "dipindah", label: "Dipindah" },
    { key: "mati_lt48", label: "Mati <48j" },
    { key: "mati_ge48", label: "Mati ≥48j" }
  ];

  bayarEvents = [
    { key: "awal", label: "Pasien Awal" },
    { key: "masuk", label: "Pasien Masuk" },
    { key: "keluar", label: "Pasien Keluar" }
  ];

  get monthLabel(): string {
    return this.month ? moment(this.month, "YYYY-MM").format("MMMM YYYY") : "-";
  }

  get canSearch(): boolean {
    return !!this.month;
  }

  get hasExcel(): boolean {
    return this.excelReports.includes(this.activeReport);
  }

  get activeTitle(): string {
    const r = this.reports.find(x => x.report === this.loadedReport);
    return r ? r.title : "";
  }

  get activeDesc(): string {
    const r = this.reports.find(x => x.report === this.activeReport);
    return r ? r.desc : "";
  }

  get borRows(): Rp1BorBaris[] {
    if (this.loadedReport !== "data-bor" || !this.data) return [];
    const d = this.data as Rp1DataBor;
    return [...d.rows, d.total];
  }

  get rinciTabel(): { key: "bayar" | "kelas"; judul: string; rinci: Rp1PenderitaRinci<string> }[] {
    if (this.loadedReport !== "data-penderita" || !this.data) return [];
    const d = this.data as Rp1DataPenderita;
    return [
      { key: "bayar", judul: "Rinci per Cara Bayar", rinci: d.bayar },
      { key: "kelas", judul: "Per Kelas", rinci: d.kelas }
    ];
  }

  legenda(kolom: { label: string; nama?: string }[]): string {
    return kolom
      .filter(k => k.nama)
      .map(k => `${k.label} = ${k.nama}`)
      .join("; ");
  }

  get days(): number[] {
    const n = this.data?.days_in_month ?? 0;
    return Array.from({ length: n }, (_, i) => i + 1);
  }

  @Watch("activeReport")
  onReportChange(val: Rp1Report) {
    this.data = null;
    this.loadedReport = null;
    this.syncQuery(val);
  }

  created() {
    const q = this.$route.query.report;
    const report = Array.isArray(q) ? q[0] : q;
    if (report && this.reports.some(r => r.report === report)) {
      this.activeReport = report as Rp1Report;
    }
  }

  mounted() {
    this.loadUnits();
  }

  syncQuery(report: Rp1Report) {
    if (this.$route.query.report === report) return;
    this.$router
      .replace({ name: "rl1-ranap", query: { report } })
      .catch(() => undefined);
  }

  goMenu() {
    this.$router.push({ name: "laporan-rp1-menu" });
  }

  async loadUnits() {
    this.loadingUnits = true;
    try {
      const data = await Referensi.getUnitPelayanan();
      const all: UnitOption[] = (data ?? []).map((u: { id: string | number; nama: string }) => ({
        id: String(u.id),
        nama: u.nama
      }));
      this.unitOptions = all
        .filter(u => u.id >= "50" && u.id < "80")
        .sort((a, b) => a.id.localeCompare(b.id));
    } catch {
      this.unitOptions = [];
    } finally {
      this.loadingUnits = false;
    }
  }

  async tampilkan() {
    const m = moment(this.month, "YYYY-MM");
    this.loading = true;
    try {
      this.data = await LaporanRl1Ranap.rp1Preview(this.activeReport, {
        tahun: m.year(),
        bulan: m.month() + 1,
        unit: this.selectedUnits
      });
      this.canEdit = !!(this.data && this.data.can_edit);
      this.loadedReport = this.activeReport;
    } finally {
      this.loading = false;
    }
  }

  async cetak() {
    const m = moment(this.month, "YYYY-MM");
    this.printing = true;
    try {
      await LaporanRl1Ranap.openRp1Pdf(this.activeReport, {
        tahun: m.year(),
        bulan: m.month() + 1,
        unit: this.selectedUnits
      });
    } finally {
      this.printing = false;
    }
  }

  async unduhExcel() {
    const m = moment(this.month, "YYYY-MM");
    this.exporting = true;
    try {
      await LaporanRl1Ranap.downloadRp1Excel(this.activeReport, {
        tahun: m.year(),
        bulan: m.month() + 1,
        unit: this.selectedUnits
      });
    } finally {
      this.exporting = false;
    }
  }

  get canKelolaTt(): boolean {
    return userModule.isSuperAdmin;
  }

  angka(v: number | null): string {
    return v === null || v === undefined ? "" : v.toLocaleString("id-ID");
  }

  desimal(v: number | null, r: Rp1BorBaris): string {
    if (r.tt === null) return "";
    if (v === null || v === undefined) return "–";
    return v.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  persen(v: number | null): string {
    if (v === null || v === undefined) return "belum tersedia";
    return `${v.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get adaLegacy(): boolean {
    if (!this.data || !this.data.wards) return false;

    return this.data.wards.some((w: RekapWard) => w.sumber_hitung === "legacy");
  }

  gantiWard(index: number, ward: RekapWard) {
    if (!this.data || !this.data.wards) return;

    this.$set(this.data.wards, index, {
      ...this.data.wards[index],
      ...ward
    });
  }

  rekapTotal(total: any, key: string): number | string {
    if (key === "sisa") return total.hari_perawatan;
    return total[key] || "";
  }

  goToMasterTt() {
    this.$router.push({ name: "superadmin-settings" }).catch(() => undefined);
  }
}
